// extracted by mini-css-extract-plugin
export default {"BreakpointFromLarge":"(min-width: 960px)","articleLink":"ArticleRelated_articleLink__5ZV8B","articleBoxGradient":"ArticleRelated_articleBoxGradient__1qOsA"};